<div mat-dialog-content>
  <form  autocomplete="off">
    <div style="margin-top: 3%; margin-bottom: 2%;">
      <div style="width: 100%;display: inline-block;">

        <div class="row m-0 eip-pt-20">
          <div class="drop-down-dev">
            <mat-button-toggle-group name="fontStyle"  aria-label="Font Style"
              [value]="Trans_Type" (change)="onToggleFormatChange($event.value)">
              <mat-button-toggle value="Internal">Internal</mat-button-toggle>
              <mat-button-toggle value="External">External</mat-button-toggle>
              <!-- <mat-button-toggle value="EDMS">EDMS</mat-button-toggle> -->
            </mat-button-toggle-group>
          </div>
          <div class="drop-down-dev">
            <button style="margin-top: 1%;margin-left: 20%;" class="btn btn-primary btn-sm"
              (click)="finalView()">Search</button>
          </div>
        </div>

      </div>
    </div>
  </form>
</div>
<div *ngIf="Trans_Type=='Internal'">
  <kendo-grid [kendoGridBinding]="CommunicationProtocolList" [sortable]="true" [resizable]="true"
    [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [filterable]="false" [pageable]="true"
    id="grvInternal">
    <ng-template kendoPagerTemplate>
      <div class="k-pager-left">
        <kendo-pager-info></kendo-pager-info>
      </div>
      <div class="k-pager-right">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-input></kendo-pager-input>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </div>
      <ng-template kendoGridToolbarTemplate>
        <div class="divider-container d-none d-md-block" id="imgDivider">
          <span></span>
        </div>
        <div class="icons-container">
          <div class="icon-wrap">
            <i class="fa fa-filter" style="float: right;" title="Filter" (click)="toggleFilter()"
              aria-hidden="true"></i>
            <!-- <span class="list-icon-name">Filter</span> -->
          </div>
        </div>
      </ng-template>
    </ng-template>
    <kendo-grid-column title="SL No" width="30">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        {{rowIndex + 1}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Name" field="staff_name" width="140">
    </kendo-grid-column>
    <kendo-grid-column title="Role" field="role_desc" width="100">
    </kendo-grid-column>
    <kendo-grid-column title="Discipline" field="disc_Description" width="140">
    </kendo-grid-column>
    <kendo-grid-column title="Designation" field="designation" width="100">
    </kendo-grid-column>
    <kendo-grid-column title="Mail ID" field="mail_id" width="100">
    </kendo-grid-column>
    <kendo-grid-column title="Mobile" field="mobile" width="100">
    </kendo-grid-column>
    <kendo-grid-column title="Scope of work to be delivered" field="scope_of_work" width="140">
    </kendo-grid-column>
    <kendo-grid-column title="Action" width="100">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex" style="cursor: pointer;">
        <i class="fa fa-save icon-my-10" (click)="addmembers(dataItem)" aria-hidden="true"  title="Create Member"
          id="btnEDMCreate"></i>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>
</div>
<div *ngIf="Trans_Type=='External'">
  <kendo-grid [kendoGridBinding]="ExternalCommunicationProtocolList" [sortable]="true" [resizable]="true"
    [filterable]="enableFilter" [reorderable]="true" [pageSize]="15" [filterable]="true" [pageable]="true"
    id="grvExternal">
    <ng-template kendoPagerTemplate>
      <div class="k-pager-left">
        <kendo-pager-info></kendo-pager-info>
      </div>
      <div class="k-pager-right">
        <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
        <kendo-pager-input></kendo-pager-input>
        <kendo-pager-next-buttons></kendo-pager-next-buttons>
      </div>
      <ng-template kendoGridToolbarTemplate>
        <div class="divider-container d-none d-md-block" id="imgDivider">
          <span></span>
        </div>
        <div class="icons-container">
          <div class="icon-wrap">
            <i class="fa fa-filter" style="float: right;" title="Filter" (click)="toggleFilter()"
              aria-hidden="true"></i>
          </div>
        </div>
      </ng-template>
    </ng-template>
    <kendo-grid-column title="SL No" width="30">
      <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
        {{rowIndex + 1}}
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column title="Member Type" field="member_Type_Desc" width="140">
    </kendo-grid-column>
    <kendo-grid-column title="Member Group" field="member_Desc" width="140">
    </kendo-grid-column>
    <kendo-grid-column title="Name" field="name" width="140">
    </kendo-grid-column>
    <kendo-grid-column title="Designation" field="designation" width="100">
    </kendo-grid-column>
    <kendo-grid-column title="Mail ID" field="email" width="100">
    </kendo-grid-column>
    <kendo-grid-column title="Is Contact Person" field="coordinator" width="140">
    </kendo-grid-column>
  </kendo-grid>
</div>